/*
 * @Author: edvardchen
 * @Date:   2017-02-09 15:47:13
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2017-02-09 15:52:47
 */

import { isQQBrowser } from './UA';
import str2bool from './str2bool';

/**
 * 是否在分享场景内
 * URL参数share为rue，且不在QB内
 * @param  {String} options.userAgent
 * @param  {Object} options.query
 * @return {Boolean}
 */
export default function withinShare({ userAgent, query }) {
  const isQB = isQQBrowser(userAgent);

  let { share } = query;
  share = str2bool(share);

  return share && !isQB;
}
